(function () {
  if (window.TradecDeliveryPreference) return;

  var ATTR = {
    attendance: 'Delivery attendance',
    safePlace: 'Safe place requested',
    instructions: 'Safe place instructions',
    terms: 'Safe place terms accepted'
  };

  var GENERIC_ERROR = 'Please complete the delivery information before continuing to checkout.';
  var SAVE_ERROR = 'We couldn’t save your delivery preference. Please try again.';
  var CLEAR_KEYS = [ATTR.attendance, ATTR.safePlace, ATTR.instructions, ATTR.terms];

  var saveToken = 0;
  var lastSavedSignature = '';
  var clearing = false;

  function qs(root, selector) {
    return root.querySelector(selector);
  }

  function qsa(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function roots() {
    return qsa(document, '[data-delivery-preference]');
  }

  function checkoutButtons() {
    return qsa(
      document,
      '.cart-recap__checkout, .mini-cart [name="checkout"], form.cart-recap [name="checkout"], button[name="checkout"]'
    ).filter(function (button) {
      return button.closest('.product-form') == null;
    });
  }

  function acceleratedButtons() {
    return qsa(
      document,
      'shopify-accelerated-checkout-cart, .additional-checkout-buttons, [data-shopify="payment-button"]'
    ).filter(function (el) {
      return el.closest('.product-form') == null && el.closest('.product') == null;
    });
  }

  function qualifyingRoot() {
    return roots().filter(function (root) {
      return root.getAttribute('data-qualifies') === 'true';
    })[0] || null;
  }

  function checkedValue(root, field) {
    var input = qs(root, '[data-dp-field="' + field + '"]:checked');
    return input ? input.value : '';
  }

  function instructionsValue(root) {
    var field = qs(root, '[data-dp-field="instructions"]');
    return field ? String(field.value || '').replace(/^\s+|\s+$/g, '') : '';
  }

  function termsChecked(root) {
    var field = qs(root, '[data-dp-field="terms"]');
    return !!(field && field.checked);
  }

  function buildState(root) {
    var attendance = checkedValue(root, 'attendance');
    var safePlace = attendance === 'No' ? checkedValue(root, 'safe-place') : '';
    var instructions = attendance === 'No' && safePlace === 'Yes' ? instructionsValue(root) : '';
    var terms = attendance === 'No' && safePlace === 'Yes' ? termsChecked(root) : false;

    return {
      attendance: attendance,
      safePlace: safePlace,
      instructions: instructions,
      terms: terms
    };
  }

  function attributesFromState(state) {
    var attrs = {};
    attrs[ATTR.attendance] = state.attendance || '';

    if (state.attendance === 'Yes') {
      attrs[ATTR.safePlace] = 'Not applicable';
      attrs[ATTR.instructions] = '';
      attrs[ATTR.terms] = 'Not applicable';
    } else if (state.attendance === 'No' && state.safePlace === 'No') {
      attrs[ATTR.safePlace] = 'No';
      attrs[ATTR.instructions] = '';
      attrs[ATTR.terms] = 'Not applicable';
    } else if (state.attendance === 'No' && state.safePlace === 'Yes') {
      attrs[ATTR.safePlace] = 'Yes';
      attrs[ATTR.instructions] = state.instructions;
      attrs[ATTR.terms] = state.terms ? 'Yes' : '';
    } else {
      attrs[ATTR.safePlace] = '';
      attrs[ATTR.instructions] = '';
      attrs[ATTR.terms] = '';
    }

    return attrs;
  }

  function signature(attrs) {
    return [
      attrs[ATTR.attendance] || '',
      attrs[ATTR.safePlace] || '',
      attrs[ATTR.instructions] || '',
      attrs[ATTR.terms] || ''
    ].join('|');
  }

  function isComplete(state) {
    if (state.attendance === 'Yes') return true;
    if (state.attendance === 'No' && state.safePlace === 'No') return true;
    if (state.attendance === 'No' && state.safePlace === 'Yes') {
      return state.instructions.length >= 5 && state.instructions.length <= 250 && state.terms;
    }
    return false;
  }

  function firstIncomplete(root, state) {
    if (!state.attendance) return qs(root, '[data-dp-field="attendance"]');
    if (state.attendance === 'No' && !state.safePlace) return qs(root, '[data-dp-field="safe-place"]');
    if (state.attendance === 'No' && state.safePlace === 'Yes') {
      if (state.instructions.length < 5 || state.instructions.length > 250) {
        return qs(root, '[data-dp-field="instructions"]');
      }
      if (!state.terms) return qs(root, '[data-dp-field="terms"]');
    }
    return null;
  }

  function errorMessage(field, state) {
    if (field === 'instructions') {
      if (!state.instructions) return GENERIC_ERROR;
      if (state.instructions.length < 5) return 'Please enter at least 5 characters.';
      if (state.instructions.length > 250) return 'Please keep this to 250 characters or fewer.';
    }
    return GENERIC_ERROR;
  }

  function setLive(root, message) {
    var live = qs(root, '[data-dp-live]');
    if (live) live.textContent = message || '';
  }

  function clearErrors(root) {
    qsa(root, '[data-dp-error]').forEach(function (el) {
      el.hidden = true;
      el.textContent = '';
    });
    setLive(root, '');
  }

  function showError(root, field, message) {
    var el = qs(root, '[data-dp-error="' + field + '"]');
    if (el) {
      el.hidden = false;
      el.textContent = message;
    }
    setLive(root, message);
  }

  function updateHidden(root, attrs) {
    var map = {
      attendance: ATTR.attendance,
      'safe-place': ATTR.safePlace,
      instructions: ATTR.instructions,
      terms: ATTR.terms
    };

    Object.keys(map).forEach(function (key) {
      var input = qs(root, '[data-dp-hidden="' + key + '"]');
      if (input) input.value = attrs[map[key]] || '';
    });
  }

  function updatePanels(root, state) {
    var safePlacePanel = qs(root, '[data-dp-panel="safe-place"]');
    var safeYesPanel = qs(root, '[data-dp-panel="safe-place-yes"]');
    var safeNoPanel = qs(root, '[data-dp-panel="safe-place-no"]');

    if (safePlacePanel) safePlacePanel.hidden = state.attendance !== 'No';
    if (safeYesPanel) safeYesPanel.hidden = !(state.attendance === 'No' && state.safePlace === 'Yes');
    if (safeNoPanel) safeNoPanel.hidden = !(state.attendance === 'No' && state.safePlace === 'No');

    var count = qs(root, '[data-dp-count]');
    if (count) count.textContent = String(instructionsValue(root).length);
  }

  function resetDownstream(root, attendance) {
    if (attendance !== 'No') {
      qsa(root, '[data-dp-field="safe-place"]').forEach(function (input) {
        input.checked = false;
      });
    }

    if (attendance !== 'No' || checkedValue(root, 'safe-place') !== 'Yes') {
      var instructions = qs(root, '[data-dp-field="instructions"]');
      var terms = qs(root, '[data-dp-field="terms"]');
      if (instructions) instructions.value = '';
      if (terms) terms.checked = false;
    }
  }

  function lockCheckout(locked) {
    checkoutButtons().forEach(function (button) {
      button.classList.toggle('is-delivery-locked', locked);
      button.setAttribute('aria-disabled', locked ? 'true' : 'false');
    });

    acceleratedButtons().forEach(function (el) {
      el.classList.toggle('is-delivery-locked', locked);
      el.setAttribute('aria-hidden', locked ? 'true' : 'false');
    });
  }

  function emptyClearAttrs() {
    var attrs = {};
    CLEAR_KEYS.forEach(function (key) {
      attrs[key] = '';
    });
    return attrs;
  }

  function updateCart(attrs) {
    saveToken += 1;
    var token = saveToken;

    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (response) {
      if (!response.ok) throw new Error('save-failed');
      return response.json();
    }).then(function (cart) {
      if (token !== saveToken) return cart;
      lastSavedSignature = signature(attrs);
      return cart;
    });
  }

  function persist(root, options) {
    options = options || {};
    var state = buildState(root);
    var attrs = options.clear ? emptyClearAttrs() : attributesFromState(state);

    if (!options.clear) updateHidden(root, attrs);

    return updateCart(attrs)
      .then(function (cart) {
        if (!options.clear) clearErrors(root);
        refreshLock();
        return cart;
      })
      .catch(function () {
        if (!options.clear) {
          setLive(root, SAVE_ERROR);
          var live = qs(root, '[data-dp-live]');
          if (live) live.textContent = SAVE_ERROR;
          var firstError = qs(root, '[data-dp-error="attendance"]') || qs(root, '[data-dp-error]');
          if (firstError) {
            firstError.hidden = false;
            firstError.textContent = SAVE_ERROR;
          }
        }
        refreshLock();
        throw new Error('save-failed');
      });
  }

  function refreshLock() {
    var root = qualifyingRoot();
    if (!root) {
      lockCheckout(false);
      return;
    }

    var state = buildState(root);
    var attrs = attributesFromState(state);
    var complete = isComplete(state);
    var saved = complete && signature(attrs) === lastSavedSignature;
    lockCheckout(!(complete && saved));
  }

  function validate(root, show) {
    var state = buildState(root);
    clearErrors(root);

    if (isComplete(state)) return true;
    if (!show) return false;

    var field = 'attendance';
    if (state.attendance === 'No' && !state.safePlace) field = 'safe-place';
    else if (state.attendance === 'No' && state.safePlace === 'Yes' && (state.instructions.length < 5 || state.instructions.length > 250)) {
      field = 'instructions';
    } else if (state.attendance === 'No' && state.safePlace === 'Yes' && !state.terms) {
      field = 'terms';
    }

    showError(root, field, errorMessage(field, state));
    var focusEl = firstIncomplete(root, state);
    if (focusEl && typeof focusEl.focus === 'function') focusEl.focus();
    return false;
  }

  function injectDrawer() {
    var miniCart = document.querySelector('.mini-cart, form.mini-cart');
    if (!miniCart) return;

    if (qs(miniCart, '[data-delivery-preference]')) return;

    var template = document.getElementById('DeliveryPreferenceDrawerTemplate');
    if (!template || !template.content) return;

    var checkout = miniCart.querySelector('[name="checkout"], .mini-cart__checkout, .button[name="checkout"]');
    var clone = template.content.cloneNode(true);
    if (checkout && checkout.parentNode) {
      checkout.parentNode.insertBefore(clone, checkout);
    } else {
      miniCart.appendChild(clone);
    }
  }

  function hydrateFromSaved() {
    var root = qualifyingRoot();
    if (!root) {
      lastSavedSignature = '';
      return;
    }

    var state = buildState(root);
    if (!isComplete(state)) {
      lastSavedSignature = '';
      refreshLock();
      return;
    }

    lastSavedSignature = signature(attributesFromState(state));
    refreshLock();
  }

  function maybeClearBelowThreshold() {
    var nodes = roots();
    if (!nodes.length) return Promise.resolve();

    var stillQualifies = nodes.some(function (root) {
      return root.getAttribute('data-qualifies') === 'true';
    });

    if (stillQualifies || clearing) return Promise.resolve();

    clearing = true;
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var attrs = cart.attributes || {};
        var needsClear = CLEAR_KEYS.some(function (key) { return !!attrs[key]; });
        if (!needsClear) return null;
        return updateCart(emptyClearAttrs());
      })
      .catch(function () { /* keep checkout available below threshold even if clear fails */ })
      .then(function () {
        lastSavedSignature = '';
        clearing = false;
        refreshLock();
      });
  }

  function applyStateToRoot(root, state) {
    qsa(root, '[data-dp-field="attendance"]').forEach(function (input) {
      input.checked = input.value === state.attendance;
    });
    qsa(root, '[data-dp-field="safe-place"]').forEach(function (input) {
      input.checked = state.attendance === 'No' && input.value === state.safePlace;
    });
    var instructions = qs(root, '[data-dp-field="instructions"]');
    var terms = qs(root, '[data-dp-field="terms"]');
    if (instructions) instructions.value = state.attendance === 'No' && state.safePlace === 'Yes' ? state.instructions : '';
    if (terms) terms.checked = state.attendance === 'No' && state.safePlace === 'Yes' && state.terms;
    updatePanels(root, state);
    updateHidden(root, attributesFromState(state));
  }

  var saveTimer = null;
  function queueSave(root) {
    window.clearTimeout(saveTimer);
    saveTimer = window.setTimeout(function () {
      var state = buildState(root);
      if (!isComplete(state)) {
        lastSavedSignature = '';
        refreshLock();
        return;
      }
      persist(root).catch(function () {});
    }, 350);
  }

  function onRootChange(event) {
    var root = event.target.closest('[data-delivery-preference]');
    if (!root || root.getAttribute('data-qualifies') !== 'true') return;

    var field = event.target.getAttribute('data-dp-field');
    if (!field) return;

    if (field === 'attendance') resetDownstream(root, event.target.value);
    if (field === 'safe-place') resetDownstream(root, 'No');

    var state = buildState(root);
    updatePanels(root, state);
    updateHidden(root, attributesFromState(state));
    roots().forEach(function (other) {
      if (other !== root && other.getAttribute('data-qualifies') === 'true') {
        applyStateToRoot(other, state);
      }
    });
    clearErrors(root);

    if (isComplete(state)) {
      queueSave(root);
    } else {
      lastSavedSignature = '';
      refreshLock();
    }
  }

  function onCheckoutAttempt(event) {
    var root = qualifyingRoot();
    if (!root) return;

    var target = event.target;
    var submitter = event.submitter || target;
    var isCheckoutControl =
      (submitter && submitter.getAttribute && submitter.getAttribute('name') === 'checkout') ||
      (submitter && submitter.classList && submitter.classList.contains('cart-recap__checkout')) ||
      (target.matches && target.matches('form.cart-recap, form.mini-cart, .mini-cart form'));

    if (event.type === 'click') {
      var button = target.closest('[name="checkout"], .cart-recap__checkout');
      if (!button) return;
      if (button.closest('.product-form')) return;
      isCheckoutControl = true;
      submitter = button;
    }

    if (!isCheckoutControl) return;

    var state = buildState(root);
    if (!validate(root, true)) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    if (signature(attributesFromState(state)) === lastSavedSignature) {
      lockCheckout(false);
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    persist(root)
      .then(function () {
        lockCheckout(false);
        if (submitter && submitter.closest) {
          var form = submitter.closest('form');
          if (form) {
            if (typeof form.requestSubmit === 'function') form.requestSubmit(submitter);
            else form.submit();
            return;
          }
        }
        window.location.href = '/checkout';
      })
      .catch(function () {});
  }

  function refresh() {
    injectDrawer();
    roots().forEach(function (root) {
      if (root.getAttribute('data-qualifies') === 'true') {
        updatePanels(root, buildState(root));
        var count = qs(root, '[data-dp-count]');
        if (count) count.textContent = String(instructionsValue(root).length);
      }
    });
    maybeClearBelowThreshold();
    hydrateFromSaved();
    refreshLock();
  }

  document.addEventListener('change', onRootChange);
  document.addEventListener('input', function (event) {
    var root = event.target.closest('[data-delivery-preference]');
    if (!root) return;
    if (event.target.getAttribute('data-dp-field') === 'instructions') {
      onRootChange(event);
    }
  });
  document.addEventListener('click', onCheckoutAttempt, true);
  document.addEventListener('submit', onCheckoutAttempt, true);

  [
    'cart:updated',
    'cart:refresh',
    'cart:rerendered',
    'shopify:section:load',
    'theme:loading:end'
  ].forEach(function (name) {
    document.addEventListener(name, function () {
      window.setTimeout(refresh, 50);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  window.TradecDeliveryPreference = {
    refresh: refresh
  };
})();
